import * as React from 'react';

export interface IAuthPageLeftSectionProps extends React.PropsWithChildren {}

export const AuthPageLeftSection: React.FunctionComponent<
  IAuthPageLeftSectionProps
> = props => {
  return (
    <div className='relative hidden h-full flex-col bg-muted p-10 text-white lg:flex'>
      <div className='absolute inset-0 bg-zinc-900' />
      {props.children}
    </div>
  );
};
